import type { InternalAxiosRequestConfig } from 'axios'
import { getFingerprint, getIamAccessToken, getSessionId } from './authSession'

/** Attach IAM session credentials on outbound requests. */
export function applyIamAuthHeaders(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const fp = getFingerprint()
  if (fp) config.headers['X-XSRF-Token'] = fp

  const jwt = getIamAccessToken()
  if (jwt) config.headers.Authorization = `Bearer ${jwt}`

  const sid = getSessionId()
  if (sid) config.headers['X-Session-Id'] = sid

  return config
}
